module.exports = __webpack_public_path__ + "img/cibeet.d4966e3d.svg";